// hooks/useFileHandling.js
import { useCallback } from 'react'
import { MediaItemType } from 'src/model/media-directory'

export const useFileHandling = () => {
  const getMediaItemType = useCallback(fileType => {
    if (
      fileType === 'image/jpeg' ||
      fileType === 'image/jpg' ||
      fileType === 'image/png' ||
      fileType === 'image/gif'
    ) {
      return MediaItemType.IMAGE
    }
    return null
  }, [])

  return { getMediaItemType }
}
